import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import NumberInput from 'common/number-input';

const AmountTileCustom = ({ active, label, onClick, value, onChange, autoFocus }) => (
    <button
        type="button"
        className={cx(
            'flex flex-col justify-center items-center w-full transition-none text-center bg-white text-center rounded p-8 md:p-6 h-full',
            {
                'text-gray-70 shadow-lg': active,
                'text-gray-30 shadow': !active,
            }
        )}
        onClick={onClick}
    >
        <span className="block text-16 font-medium md:font-bold">{label}</span>
        {active && (
            <div className="flex items-center mt-4">
                <span className="flex-no-shrink text-18 pr-4 text-gray-40">$</span>
                <div className="flex-grow">
                    <NumberInput
                        value={value}
                        name="custom-amount"
                        inputMode="decimal"
                        className="input-default w-48"
                        onValueChange={onChange}
                        autoFocus={autoFocus}
                    />
                </div>
            </div>
        )}
    </button>
);

AmountTileCustom.propTypes = {
    value: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    active: PropTypes.bool,
    autoFocus: PropTypes.bool,
};

AmountTileCustom.defaultProps = {
    label: 'Custom',
    active: false,
    autoFocus: false,
};

export default AmountTileCustom;
